var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"content"},[_c('i',{staticClass:"el-icon-warning icon"}),_c('p',[_vm._v(" "+_vm._s(' Lệnh thanh toán của bạn đã hết hạn, vui lòng lấy lại mã QR và địa chỉ mới nhất.')+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }